<template>
  <div class="topping-rule-mapping-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  {{$t('topping.type_specials_' + topping_special)}}
                </h3>
              </strong>
            </div>
            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('common.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0"/>
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" class="header mb-0">
            <div slot="header">
              <span>
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('topping_rule_mapping.basic_information') }}</strong>
              </span>
            </div>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('single_topping_type_rule_form.type')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="text"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.type"
                          :disabled="isDisabled"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('topping_rule_mapping.topping_special')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="text"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.topping_special"
                          :disabled="isDisabled"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('single_topping_type_rule_form.min_selections')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="number"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.min_selections"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('topping_rule_mapping.max_selections')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="number"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.max_selections"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('single_topping_type_rule_form.max_removals')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="number"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.max_removals"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('topping_rule_mapping.max_repeats')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="number"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.max_repeats"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('single_topping_type_rule_form.free_swaps')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="number"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.free_swaps"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('topping_rule_mapping.free_additions')}}</legend>
                <div class="col-sm-9">
                  <b-form-input
                          type="number"
                          class="form-control border-radius-4px col-sm-5"
                          v-model="item.free_additions"
                  ></b-form-input>
                </div>
              </div>
            </b-form>
            <b-form>
              <div class="form-group row">
                <legend class="col-sm-3 col-form-label">{{$t('topping_rule_mapping.fixed')}}</legend>
                <div class="col-sm-9">
                  <c-switch class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.fixed" :value="1" :uncheckedValue="0"/>
                </div>
              </div>
            </b-form>
            <b-row>
              <b-col>
                <button type="button" class="btn border-radius-4px bg-main pull-left" v-on:click="cancel()"><i class="fa fa-times"></i>&nbsp;{{$t('category.close')}}</button>
                <div class="btn-save">
                  <button type="button" class="btn border-radius-4px bg-main pull-right" v-on:click="saveToppingRuleMapping()" ><i class="fa fa-save"></i>&nbsp; {{$t('common.save')}}</button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
  import cSwitch from '../../../components/Switch'
  import axios from 'axios'

  let vm = null

  export default {
    name: 'ToppingRuleMappingForm',
    props: {
      uuid: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      topping_special: {
        type: Number | String,
        required: true
      }
    },
    components: {
      cSwitch
    },
    data: function () {
      return {
        item: {
          id: '',
          uuid: '',
          type: 'single',
          topping_special: '',
          min_selections: 1,
          max_selections: 1,
          max_removals: 0,
          max_repeats: 0,
          free_swaps: 0,
          free_additions: 0,
          fixed: 0,
          active: 1,
        },
        isDisabled: true
      }
    },
    created: function () {
      vm = this
      vm.getDetail()
    },
    updated: function () {
    },
    methods: {
      resetItem () {
        this.item = {
          id: '',
          uuid: '',
          type: 'single',
          topping_special: '',
          min_selections: 1,
          max_selections: 1,
          max_removals: 0,
          max_repeats: 0,
          free_swaps: 0,
          free_additions: 0,
          fixed: 0,
          active: 1,
        }
      },
      getDetail () {
        vm.item.uuid = vm.uuid
        vm.item.type = vm.type
        vm.item.topping_special = vm.topping_special
        this.axios.menu.getDetailToppingRuleMapping(vm.item, function (response) {
          vm.item = response.data.data.item
        })
      },
      cancel () {
        this.$emit('cancel')
      },
      saveToppingRuleMapping () {
        let item = JSON.parse(JSON.stringify(vm.item))

        if (item.id === '') {
          this.axios.menu.createToppingRuleMapping(item, respone => {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            vm.resetItem()
            vm.$emit('success')
          }, error => {
            vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
            console.log('error', error)
          })
        } else {
          this.axios.category.updateToppingRuleMapping(item, respone => {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            vm.resetItem()
            vm.$emit('success')
          }, error => {
            vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
            console.log(error)
          })
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/menu/ToppingRuleMappingForm.vue